import { Component, OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
import { AgencyService } from '../common-theme/api/agency.service';

@Component({
  selector: 'app-downtown-life',
  templateUrl: './downtown-life.component.html',
  styleUrls: ['./downtown-life.component.scss']
})

export class DowntownLifeComponent extends SeoAwareBaseComponent implements OnInit {
  public isOpen: boolean[] = [true, false, false, false, false];
  public navLinks: any = [
    { path: '/romanescu-lifestyle/concept' },
    { path: '/romanescu-lifestyle/detalii-proiect' },
    { path: '/romanescu-lifestyle/galerie' },
    { path: '/romanescu-lifestyle/facilitati' },
    { path: '/romanescu-lifestyle/tehnic' },
    { path: '/romanescu-lifestyle/construction' }
  ];

  constructor(
    public agencyService: AgencyService,
    public injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle(this.agencyService.agency.name);
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/downtown-life.component.ts